jQuery(document).ready(function () {
  function initializeSlider() {
    if (jQuery(window).width() <= 768) {
      if (!jQuery(".product_proses_steps").hasClass("slick-initialized")) {
        jQuery(".product_proses_steps").slick({
          dots: true,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          prevArrow:
            '<button class="prev-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#000"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="#fff" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          nextArrow:
            '<button class="next-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#000"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="#fff" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        });
      }
    } else {
      if (jQuery(".product_proses_steps").hasClass("slick-initialized")) {
        jQuery(".product_proses_steps").slick("unslick");
      }
    }
  }

  initializeSlider();

  jQuery(window).resize(function () {
    initializeSlider();
  });

  $(".video-slider-wrapper").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    touchMove: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.45,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          prevArrow:
            '<button class="prev-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#FEE04F"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
          nextArrow:
            '<button class="next-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#FEE04F"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        },
      },
    ],
  });

  // customer-review-slider js start
  jQuery(document).ready(function () {
    $(".customer-review-slider").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      prevArrow:
        '<button class="prev-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#000"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="#fff" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      nextArrow:
        '<button class="next-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#000"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="#fff" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding:'30px',
          },
        },
      ],
    });
  });

  /************************************************
   * Video Slider section play video start js *
   ************************************************/
  //video play icon click
  jQuery(document).on(
    "click",
    ".video-slider-section .slide-item .play-btn",
    function () {
      jQuery(this).prev("video").trigger("play");
      jQuery(this).hide();
      jQuery(this)
        .next(".video-control-box")
        .find(".contorl-box.play-ctrl")
        .addClass("active");
    }
  );

  //video play and pause
  jQuery(document).on(
    "click",
    ".video-slider-section .video-control-box .contorl-box.play-ctrl",
    function () {
      if (jQuery(this).hasClass("active")) {
        jQuery(this)
          .parent()
          .parent()
          .parent("div")
          .find("video")
          .trigger("pause");
        jQuery(this).removeClass("active");
      } else {
        jQuery(this)
          .parent()
          .parent()
          .parent("div")
          .find("video")
          .trigger("play");
        jQuery(this).addClass("active");
        jQuery(this).parent().parent().parent("div").find(".play-btn").hide();
      }
    }
  );
  //video mute and unmute
  jQuery(document).on(
    "click",
    ".video-slider-section .video-control-box .contorl-box.volum-ctrl",
    function () {
      var videos = jQuery(this).parent().parent().parent("div").find("video");
      var video = videos[0]; // Get the video element
      video.muted = !video.muted;
      if (jQuery(this).hasClass("active")) {
        jQuery(this).removeClass("active");
      } else {
        jQuery(this).addClass("active");
      }
    }
  );

  //full screen video
  jQuery(document).on(
    "click",
    ".video-slider-section .video-control-box .contorl-box.full-screen",
    function () {
      var videos = jQuery(this).parent().parent().parent("div").find("video");
      var videoelement = videos[0]; // Get the video element
      if (videoelement.requestFullscreen) {
        videoelement.requestFullscreen();
      } else if (videoelement.webkitRequestFullscreen) {
        videoelement.webkitRequestFullscreen();
      } else if (videoelement.mozRequestFullScreen) {
        videoelement.mozRequestFullScreen();
      } else if (videoelement.msRequestFullscreen) {
        videoelement.msRequestFullscreen();
      }
    }
  );

  /************************************************
   * Video Slider section play video end js  *
   ************************************************/

  /************************************************
   * logo marquee start js  *
   ************************************************/

    const scrollers = document.querySelectorAll(".scroller");

    if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        addAnimation();
    }

    function addAnimation() {
        scrollers.forEach(scroller => {
            scroller.setAttribute("data-animated", true);

            const scrollerInner = scroller.querySelector('.scroller__inner');
            const scrollerContent = Array.from(scrollerInner.children);

            scrollerContent.forEach(item => {
                const duplicatedItem = item.cloneNode(true);
                duplicatedItem.setAttribute('aria-hidden', true);
                scrollerInner.appendChild(duplicatedItem);
            });
        });
    }

  /************************************************
   * logo marquee end js  *
   ************************************************/

  /************************************************
   * logo list slider start js  *
   ************************************************/

  $(".logo-list-feature").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    focusOnSelect: true,
    asNavFor: ".sync-content-slider",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        },
      },
    ],
  });
});
$(".sync-content-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: ".logo-list-feature",
  arrows: true,
  infinite: true,
  prevArrow:
    '<button class="prev-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#FEE04F"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  nextArrow:
    '<button class="next-arrow"><svg data-id="512490249243329641" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none"><rect y="0.610352" width="40" height="40" rx="20" fill="#FEE04F"></rect><path d="M17.5 25.6104L22.5 20.6104L17.5 15.6104" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  dots: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {},
    },
  ],
});

$(".logo-list-feature").on("click", ".img-box", function() {
  var index = $(this).index();
  $(".logo-list-feature").slick("slickGoTo", index);
  // .sync-content-slider will update automatically because of asNavFor
});

/************************************************
 * logo list slider end js  *
 ************************************************/

/**********************************************************************
 *  sections/landing-custom-product.liquid -- START  *
 **********************************************************************/
// cp panel
jQuery(document).on("click", ".cppanel-heading", function (e) {
    e.preventDefault();
    var $this = jQuery(this);
    var $content = $this.siblings(".cppanel-content");

    if ($this.hasClass("active")) {
      // Close the clicked accordion
      $this.removeClass("active").attr("aria-expanded", "false");
      $content.slideUp(200);

      jQuery(".cppanel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      // Reset all other icons
      jQuery(".cppanel-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");

      // Update clicked icon
      $this.find("i").removeClass("fa-plus").addClass("fa-minus");

      // Close all other accordions
      jQuery(".cppanel-heading")
        .removeClass("active")
        .attr("aria-expanded", "false");
      jQuery(".cppanel-content").slideUp(200);

      // Open the clicked accordion
      $this.addClass("active").attr("aria-expanded", "true");
      $content.slideDown(200);
    }
  });
// cp gallery
$(".cpmain-gallery").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
  dots: false,
  infinite: true,
  speed: 300,
  asNavFor: ".cpthumb-gallery",
  prevArrow:
    '<button type="button" class="slick-prev slick-arrow" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 30"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.959" d="m11.817 23.382 8.57-8.57-8.57-8.571"/></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next slick-arrow" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 30"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.959" d="m11.817 23.382 8.57-8.57-8.57-8.571"/></svg></button>',
});
$(".cpthumb-gallery").slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: ".cpmain-gallery",
  dots: false,
  arrows: false,
  centerMode: false,
  vertical: false,
  focusOnSelect: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        //variableWidth: true,
        vertical: false,
      },
    },
  ],
});
// cp variant flavour
document.addEventListener("DOMContentLoaded", function () {
  const swatchItems = document.querySelectorAll(".cpswatch-item");
  const contentBlocks = document.querySelectorAll(".cpblock--content");
  const portionBlocks = document.querySelectorAll(".cp-portions");
  const portionItems = document.querySelectorAll(".cp-portions-item");
  const subscribeSections = document.querySelectorAll(".cp-portion-subscribe");


  // Function to handle portion selection
  portionItems.forEach((item) => {
    item.addEventListener("click", function () {
      // Remove active class from all portion items
      portionItems.forEach((el) => el.classList.remove("active"));

      // Hide all subscribe sections
      subscribeSections.forEach((section) => (section.style.display = "none"));
      subscribeSections.forEach((section) => section.classList.remove("active"));

      // Add active class to clicked portion item
      this.classList.add("active");

      // Show corresponding subscribe section
      const targetSubscribeId = this.getAttribute("data-subscribe");
      const targetSubscribe = document.getElementById(targetSubscribeId);
      if (targetSubscribe) {
        targetSubscribe.style.display = "block";
        targetSubscribe.classList.add("active");

        // Check the first radio input
        const radios = targetSubscribe.querySelectorAll("input[type='radio']");
        if (radios.length > 0) {
          radios[0].checked = true;
          updatePriceAttributes(radios[0]); // Update price attributes on initial selection
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const swatchItems = document.querySelectorAll(".cpswatch-item");
  const portionBlocks = document.querySelectorAll(".cp-portions");
  const contentBlocks = document.querySelectorAll(".cpblock--content");

  swatchItems.forEach((item) => {
    item.addEventListener("click", function () {
      // Remove active class from all swatches
      swatchItems.forEach((el) => el.classList.remove("active"));
      contentBlocks.forEach((block) => (block.style.display = "none"));

      // Hide all portion blocks
      portionBlocks.forEach((block) => (block.style.display = "none"));
      portionBlocks.forEach((block) => block.classList.remove("active"));

      // Add active class to clicked swatch
      this.classList.add("active");

      // Get target portion block
      const targetId = this.getAttribute("data-title");
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.style.display = "block";
      }
      const targetPortion = document.getElementById(`portions-${targetId}`);

      if (targetPortion) {
        targetPortion.style.display = "block";
        targetPortion.classList.add("active");

        // Remove active class from all portion items within the target portion block
        const portionItems = targetPortion.querySelectorAll(".cp-portions-item");
        portionItems.forEach((item) => item.classList.remove("active"));

        // Set first portion item as active
        if (portionItems.length > 0) {
          portionItems[0].classList.add("active");

          // Hide all subscription sections
          const subscribeSections = document.querySelectorAll(".cp-portion-subscribe");
          subscribeSections.forEach((section) => (section.style.display = "none"));
          subscribeSections.forEach((section) => section.classList.remove("active"));

          // Uncheck all radio buttons
          const allRadios = document.querySelectorAll(".cp-portion-subscribe input[type='radio']");
          allRadios.forEach((radio) => (radio.checked = false));

          // Get target subscription block from the first active portion item
          const subscribeId = portionItems[0].getAttribute("data-subscribe");
          const targetSubscribe = document.getElementById(subscribeId);

          if (targetSubscribe) {
            targetSubscribe.style.display = "block";
            targetSubscribe.classList.add("active");

            // Check the first radio input
            const radios = targetSubscribe.querySelectorAll("input[type='radio']");
            if (radios.length > 0) {
              radios[0].checked = true;
              updatePriceAttributes(radios[0]); // Update price attributes on initial selection
            }
          }
        }
      }
    });
  });
});

// Function to update price attributes and UI when a radio is checked
function updatePriceAttributes(radio) {
  const parentDiv = radio.closest(".subscribe-item");
  if (parentDiv) {
    const cprice = parentDiv.getAttribute("data-cprice") || "";
    const price = parentDiv.getAttribute("data-price") || "";
    const saveprice = parentDiv.getAttribute("data-saveprice") || "";

    // Update price display
    const priceContainer = document.querySelector(".price-item-lading");
    if (priceContainer) {
      const comparePriceElem = priceContainer.querySelector(".compare-price");
      const moneyElem = priceContainer.querySelector(".money");
      const savePriceElem = priceContainer.querySelector(".save-price");
      const inlineSpace = priceContainer.querySelector(".inline-space-between");

      // Update values
      if(cprice != ''){
        comparePriceElem.style.display = "inline"; // show compare price
        comparePriceElem.textContent = `${cprice}`;
      }
      else{
        comparePriceElem.style.display = "none"; // hide compare price
      }
      moneyElem.textContent = `${price}`;

      var saveText = savePriceElem.getAttribute('data-savetext');

      // Calculate savings
      if (saveprice != '') {
        savePriceElem.textContent = `${saveText} ${saveprice}!`;
        savePriceElem.style.display = "inline"; // Show save price
        inlineSpace.classList.add("save"); // Add 'save' class
      } else {
        savePriceElem.style.display = "none"; // Hide save price
        inlineSpace.classList.remove("save"); // Remove 'save' class
      }
    }
  }
}

// Event listener for radio button changes
document.addEventListener("change", function (event) {
  if (event.target.matches(".cp-portion-subscribe input[type='radio']")) {
    updatePriceAttributes(event.target);
  }
});

// cp modal
document.addEventListener("DOMContentLoaded", function() {
    // Get all modal trigger buttons, modals, and close buttons
    const buttons = document.querySelectorAll('.cppopup-button');
    const modals = document.querySelectorAll('.cppopup-modal');
    const closeButtons = document.querySelectorAll('.cppopup-modal-close');

    // Function to open modal
    function openModal(modal) {
        modal.style.display = 'flex';  // Show modal
        document.body.classList.add('cpmodal-overflow');  // Add class to body
    }

    // Function to close modal
    function closeModal(modal) {
        modal.style.display = 'none';  // Hide modal
        document.body.classList.remove('cpmodal-overflow');  // Remove class from body
    }

    // Attach event listeners to each button
    buttons.forEach((button, index) => {
        button.addEventListener('click', function() {
            openModal(modals[index]);
        });
    });

    // Attach event listeners to close buttons
    closeButtons.forEach((closeButton, index) => {
        closeButton.addEventListener('click', function() {
            closeModal(modals[index]);
        });
    });

    // Close modal when clicking outside of the modal content
    modals.forEach((modal) => {
        modal.addEventListener('click', function(event) {
            if (event.target === modal) {
                closeModal(modal);
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector(".button-addtocart");

  if (addToCartButton) {
    addToCartButton.addEventListener("click", function () {
      // Find the active portion block
      const activePortion = document.querySelector(".cp-portions.active");

      if (activePortion) {
        // Find the active subscription block inside the active portion
        const activeSubscribe = activePortion.querySelector(".cp-portion-subscribe.active");

        if (activeSubscribe) {
          // Get the checked radio button inside the active subscription block
          const checkedRadio = activeSubscribe.querySelector("input[type='radio']:checked");

          if (checkedRadio) {
            const sellingplan = checkedRadio.getAttribute("data-sellingplan") || "";
            const vid = checkedRadio.value;
            console.log("Selected value:", vid);
            console.log("Selected sellingplan:", sellingplan);

            const hiddenVidInput = document.getElementById("product__frm__hidden_id");
            const hiddenSellingPlanInput = document.getElementById("selling_plan__hidden_id");
            const hiddenSubmitButton = document.getElementById("ProductSubmitButton_hidden");

            if (hiddenVidInput && hiddenSellingPlanInput && hiddenSubmitButton) {

              // Show loading spinner if it exists
              const spinner = addToCartButton.querySelector(".loading-overlay__spinner");
              if (spinner) {
                spinner.classList.remove("hidden");

                // Optional: auto-hide after 3s fallback if no AJAX success listener
                setTimeout(() => {
                  spinner.classList.add("hidden");
                }, 3000);
              }

              hiddenVidInput.value = vid;
              hiddenSellingPlanInput.value = sellingplan;
              hiddenSubmitButton.click();
              document.body.classList.add("cart__drawer__open");
            } else {
              console.warn("One or more hidden input fields are missing.");
            }
          } else {
            console.warn("No radio button selected in active subscription.");
          }
        } else {
          console.warn("No active subscription found.");
        }
      } else {
        console.warn("No active portion found.");
      }
    });
  } else {
    console.log("Add to Cart button (.button-addtocart) not found.");
  }
});


/**********************************************************************
 *  sections/landing-custom-product.liquid -- END  *
 **********************************************************************/

/**********************************************************************
 *  banner popu js -- START  *
 **********************************************************************/

$(document).ready(function () {
  $(".banner-popup-wrapper").hide();

  $(".pop-up-btn").click(function () {
    $(".banner-popup-wrapper").fadeIn(150);
    $(".popup-overlay").addClass("show");
    $("body").addClass("scroll-none");
  });
  $(".popup-overlay , .popup-close-btn").click(function () {
    $(".banner-popup-wrapper").fadeOut(150);
    $(".popup-overlay").removeClass("show");
    $("body").removeClass("scroll-none");
  });
});

/**********************************************************************
 *  banner popu js -- END  *
 **********************************************************************/

/********************************************************************************
 *  maintent button show hide for add to cart button when showing js -- START  *
 ********************************************************************************/

/************************* Landing page for Easy Maintent Button Show Hide JS start **********************/

$(document).ready(function () {
  if($("#landing-cpproduct").length){
    var section = $('.customer-heading-review');
    var section1 = $("#landing-cpproduct").offset().top;
    var buttonHeight = $("#landing-cpproduct").find('.cpgrid-item.cpgrid--gallery');
    var buttons = $(".button-sticky");
    var heightDiv = 0;
    jQuery('#landing-cpproduct').find('.cpblock.cpblock--panel').each(function() {
        heightDiv+=jQuery(this).outerHeight();
    });
    heightDiv = Math.round(heightDiv);
    section1 = Math.round(section1+buttonHeight.outerHeight()+heightDiv);
    if(jQuery('.guaranteed-quality').length>0){
      section1+=jQuery('.guaranteed-quality').outerHeight();
    }
    function checkVisibilityButton() {
        var windowTop = Math.round($(window).scrollTop());
        var windowBottom = Math.round(windowTop + $(window).height());
        var sectionTop = Math.round(section.offset().top+buttonHeight.outerHeight()+heightDiv);
        var sectionBottom = Math.round(sectionTop + section.outerHeight()+buttonHeight.outerHeight());
        //console.log('windowBottom',sectionBottom+'>'+windowTop,sectionTop+'<'+windowBottom,section1);
        if (sectionBottom > windowTop && sectionTop < windowBottom) {
            buttons.hide();
        }else if(section1>windowTop && sectionTop < windowBottom) {
            buttons.hide();
        } else {
            buttons.show();
        }
    }
    if (jQuery(window).width() < 768) {
      checkVisibilityButton();
      $(window).on("scroll", function () {
          checkVisibilityButton();
      });
    }
  }
});

/************************* Landing page for Easy Maintent Button Show Hide JS END **********************/

jQuery(window).on("scroll", function () {
    const target = jQuery(".landing-customproduct").find('.button-addtocart');
    const hideshowSize = jQuery(".round-btn");
    const windowHeight = jQuery(window).height();
    const scrollTop = jQuery(window).scrollTop();

    // Check if the target element exists and has offset
    if (target.length > 0) {
        const elementOffset = target.offset().top;

        if (scrollTop + windowHeight > elementOffset) {
            hideshowSize.hide();
        } else {
            hideshowSize.show();
        }
    }
});

/********************************************************************************
 *  maintent button show hide for add to cart button when showing js -- END  *
 ********************************************************************************/


// START :: CART ANNOUNCEMENT SLIDER
function cartAnnounceSlider(){
  $('.cart_announce_slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: true,
      loop:true,
    autoplay: true,
  autoplaySpeed: 3000,
     prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M12.8417 6.675L9.02501 10.5L12.8417 14.325L11.6667 15.5L6.66667 10.5L11.6667 5.5L12.8417 6.675Z" fill="black"/></path></svg></button>',
     nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M7.15833 6.675L10.975 10.5L7.15833 14.325L8.33333 15.5L13.3333 10.5L8.33333 5.5L7.15833 6.675Z" fill="black"/></path></svg></button>',
  });
}
setInterval(function(){
  if($('cart-drawer').hasClass('active')){
    if($('.cart_announce_slider').hasClass('slick-initialized') == false){
      cartAnnounceSlider();
    }
  }
}, 500);
// END :: CART ANNOUNCEMENT SLIDERom

// START :: HEADER FIXED
$(document).ready(function () {
    let $announcementBar = $(".landing-announcement-bar");

    function handleScroll() {
        if (!$announcementBar.length) return;

        let rect = $announcementBar[0].getBoundingClientRect();
        if (rect.bottom <= 0) {
            $("body").addClass("announcement-hidden");
        } else {
            $("body").removeClass("announcement-hidden");
        }
    }

    $(window).on("scroll", handleScroll);
    handleScroll();
});

// END :: HEADER FIXED
/*************** LANDING PAGE FOOTER BUTTON CLICK PRODUCTS SECTION ON MOBILE TO SCROLL START *****************/
jQuery(document).on("click",".shopify-section-group-footer-group .button-sticky",function(){
  if(jQuery(window).width()<768){
    if(jQuery('.landing-customproduct').length>0){
      jQuery('html,body').animate({
        scrollTop:jQuery('.landing-customproduct').offset().top
      });
    }
  }
});
/*************** LANDING PAGE FOOTER BUTTON CLICK PRODUCTS SECTION ON MOBILE TO SCROLL END *****************/

/*************** LANDING PAGE PRODUCT MIX TO URL WISE SELECTED VARIANT JS START *****************/
jQuery(document).ready(function(){
  var url = window.location.href;
  var lastSegment = url.substring(url.lastIndexOf('/') + 1).split('?')[0].split('#')[0];
  var orinaleArr = ['originale-30','originale-60','originale-90'];
  var cafeArr = ['cafe-30','cafe-60','cafe-90'];
  var cafedecafArr = ['cacao-decaf-30','cacao-decaf-60','cacao-decaf-90'];
  var onetimeSubscirbe = ['30-tasses','60-tasses','90-tasses'];
  if(orinaleArr.includes(lastSegment)){
    setUrlwiseVariants(lastSegment,1);
  }else if(cafeArr.includes(lastSegment)){
    setUrlwiseVariants(lastSegment,2);
  }else if(cafedecafArr.includes(lastSegment)){
    setUrlwiseVariants(lastSegment,3);
  }else if(lastSegment == '60-tasses-offre-decouverte'){
    lastSegment = 'originale-60';
    setUrlwiseVariants(lastSegment,1);
  }else if(lastSegment == '90-tasses-offre-decouverte'){
    lastSegment = 'originale-90';
    setUrlwiseVariants(lastSegment,1);
  }else if(onetimeSubscirbe.includes(lastSegment)){
    if(lastSegment=='30-tasses'){
      lastSegment = 'originale-30';
    }else if(lastSegment=='60-tasses'){
      lastSegment = 'originale-60';
    }else if(lastSegment=='90-tasses'){
      lastSegment = 'originale-90';
    }
    setUrlwiseVariants(lastSegment,4);
  }
});

function setUrlwiseVariants(lastSegment,type){
  jQuery('.cpblock--variantproduct').find('.cp-portions').removeClass('active');
  jQuery('.cpblock--variantproduct').find('.cpblock--content').hide();

  if(type==1 || type==4){
    jQuery('.cpblock--variantproduct').find('.cafe-main').hide();
    jQuery('.cpblock--variantproduct').find('.cacao-decaf-main').hide();

    if(jQuery('.cpblock--variantproduct').find('.portions-cpp-originale').length>0){
      jQuery('.cpblock--variantproduct').find('.portions-cpp-originale').show();
      jQuery('.cpblock--variantproduct').find('.portions-cpp-originale').addClass('active');
      jQuery('.cpblock--variantproduct').find('.cpblock--content.originale-content').show();
      jQuery('.cpblock--variantproduct').find('.price-item-lading.'+lastSegment+'-main-price').show();

      if(jQuery('.cpblock--variantproduct').find('.cp-portions-item[data-variant="'+lastSegment+'"]').length>0){
        jQuery('.cpblock--variantproduct').find('.cp-portions-item').removeClass('active');
        jQuery('.cpblock--variantproduct').find('.cp-portions-item[data-variant="'+lastSegment+'"]').addClass('active');

        if(jQuery('.cp-portion-subscribe').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").length>0){
          jQuery('.cp-portion-subscribe').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").eq(0).attr('checked',true);
          jQuery('.cpblock--variantproduct').find('.cp-portion-subscribe').removeClass('active').hide();
          jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).parent('div').addClass('active').show();
        }
      }
    }
  }else if(type==2){
    jQuery('.cpblock--variantproduct').find('.portions-cpp-originale').hide();
    jQuery('.cpblock--variantproduct').find('.cacao-decaf-main').hide();

    if(jQuery('.cpblock--variantproduct').find('.cafe-main').length>0){
      jQuery('.cpblock--variantproduct').find('.cafe-main').show();
      jQuery('.cpblock--variantproduct').find('.cpvariant-swatch-grid').find('.cpswatch-item').removeClass('active');
      jQuery('.cpblock--variantproduct').find('.cpvariant-swatch-grid').find('.cpswatch-item.swatch-cafe').addClass('active');
      jQuery('.cpblock--variantproduct').find('.cafe-main').addClass('active');
      jQuery('.cpblock--variantproduct').find('.cpblock--content.cafe-content').show();
      jQuery('.cpblock--variantproduct').find('.price-item-lading.'+lastSegment+'-main-price').show();

      if(jQuery('.cpblock--variantproduct .cafe-main').find('.cp-portions-item[data-variant="'+lastSegment+'"]').length>0){
        jQuery('.cpblock--variantproduct .cafe-main').find('.cp-portions-item').removeClass('active');
        jQuery('.cpblock--variantproduct .cafe-main').find('.cp-portions-item[data-variant="'+lastSegment+'"]').addClass('active');

        if(jQuery('.cp-portion-subscribe').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").length>0){
          jQuery('.cp-portion-subscribe').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").eq(0).attr('checked',true);
          jQuery('.cpblock--variantproduct').find('.cafe-main').find('.cp-portion-subscribe').hide();
          jQuery('.cpblock--variantproduct').find('.cafe-main').find('.cp-portion-subscribe').removeClass('active');
          jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).parent('div').addClass('active').show();
        }
      }
    }
  }else if(type==3){
    jQuery('.cpblock--variantproduct').find('.portions-cpp-originale').hide();
    jQuery('.cpblock--variantproduct').find('.cafe-main').hide();

    if(jQuery('.cpblock--variantproduct').find('.cacao-decaf-main').length>0){
      jQuery('.cpblock--variantproduct').find('.cacao-decaf-main').show();
      jQuery('.cpblock--variantproduct').find('.cpvariant-swatch-grid').find('.cpswatch-item').removeClass('active');
      jQuery('.cpblock--variantproduct').find('.cpvariant-swatch-grid').find('.cpswatch-item.swatch-cacao-decaf').addClass('active');
      jQuery('.cpblock--variantproduct').find('.cacao-decaf-main').addClass('active');
      jQuery('.cpblock--variantproduct').find('.cpblock--content.cacao-decaf-content').show();
      jQuery('.cpblock--variantproduct').find('.price-item-lading.'+lastSegment+'-main-price').show();

      if(jQuery('.cpblock--variantproduct .cacao-decaf-main').find('.cp-portions-item[data-variant="'+lastSegment+'"]').length>0){
        jQuery('.cpblock--variantproduct .cacao-decaf-main').find('.cp-portions-item').removeClass('active');
        jQuery('.cpblock--variantproduct .cacao-decaf-main').find('.cp-portions-item[data-variant="'+lastSegment+'"]').addClass('active');

        if(jQuery('.cp-portion-subscribe').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").length>0){
          jQuery('.cp-portion-subscribe').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").eq(0).attr('checked',true);
          jQuery('.cpblock--variantproduct').find('.cacao-decaf-main').find('.cp-portion-subscribe').hide();
          jQuery('.cpblock--variantproduct').find('.cacao-decaf-main').find('.cp-portion-subscribe').removeClass('active');
          jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).parent('div').addClass('active').show();
        }
      }
    }
  }

  if(type!=4){
    if(jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").length>0){
      jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).find(".onetime-cpp input[type='radio']").trigger('click');
      setTimeout(function(){
        jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).find(".subscribe-cpp input[type='radio']").trigger('click');
      },500);
    }
  }else{
    if(jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).find("input[type='radio']").length>0){
      jQuery('.cpblock--variantproduct').find('.cpportions-subscribe.'+lastSegment).find(".onetime-cpp input[type='radio']").trigger('click');
    }
  }
}

/*************** LANDING PAGE PRODUCT MIX TO URL WISE SELECTED VARIANT JS END *****************/

/*************** HOME PAGE REVIEW CLICK TO SCROLL REVIEW SECTION JS START *****************/
jQuery(document).on("click",'.new-bannner-section .text-no a,.landing-customproduct .cp-review-text a',function(event){
  event.preventDefault(); // Prevents the default action (optional)
  var sectionId = $(this).attr("href");
  var stickyHeaderHeight=0;
  if(jQuery('.landing--new-header').find('.new-header').length>0){
    stickyHeaderHeight=Math.round(jQuery('.landing--new-header').find('.new-header').outerHeight());
  }
  jQuery('html,body').animate({
    scrollTop:jQuery(sectionId).offset().top-stickyHeaderHeight
  });
});
/*************** HOME PAGE REVIEW CLICK TO SCROLL REVIEW SECTION JS END *****************/


jQuery(document).on('click', '.look_custom_review', function(e) {
  e.preventDefault();
  jQuery('html, body').animate({
    scrollTop: jQuery('#shopify-section-template--25026277605703__1738220922170c89de').offset().top
  }, 300); // 600ms = scroll duration
});

jQuery(document).on('click', '.client-avtar', function(e) {
  e.preventDefault();
  jQuery('html, body').animate({
    scrollTop: jQuery('#customer-review').offset().top
  }, 300); // 600ms = scroll duration
});


// START :: LISTICLE TIMER
document.addEventListener('DOMContentLoaded', function () {
  const hourMap = {
    "6hrs": 6,
    "12hrs": 12,
    "24hrs": 24,
    "48hrs": 48,
    "72hrs": 72
  };
  const selected = window.bfcmTimer || '6hrs';
  const countdownHours = hourMap[selected] || 6;
  const initialSeconds = countdownHours * 3600;
  const lastSchema = localStorage.getItem('bfcm_timer_schema');
  if (lastSchema !== selected) {
    localStorage.removeItem('bfcm_timer_remaining');
    localStorage.setItem('bfcm_timer_schema', selected);
  }
  let remaining;
  const stored = parseInt(localStorage.getItem('bfcm_timer_remaining'), 10);
  if (!isNaN(stored) && stored > 0) {
    remaining = stored;
  } else {
    remaining = initialSeconds;
  }
  function updateTimer() {
    const h = Math.floor(remaining / 3600);
    const m = Math.floor((remaining % 3600) / 60);
    const s = remaining % 60;
    setDomTime(h, m, s);
    remaining--;
    if (remaining < 0) {
      remaining = initialSeconds;
    }
    localStorage.setItem('bfcm_timer_remaining', remaining);
  }
  function setDomTime(h, m, s) {
    const pad = n => String(n).padStart(2, '0');
    const hDom = document.getElementById('cd-hours');
    const mDom = document.getElementById('cd-minutes');
    const sDom = document.getElementById('cd-seconds');
    const inline = document.getElementById('cd-inline');
    if (hDom) hDom.textContent = pad(h);
    if (mDom) mDom.textContent = pad(m);
    if (sDom) sDom.textContent = pad(s);
    if (inline) inline.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
  }
  updateTimer();
  setInterval(updateTimer, 1000);
});
// END :: LISTICLE TIMER


//LISTICLE PAGE STAR BUTTON STICKY SPECIFIC SECTION SCROLL START
jQuery(document).ready(function(){
  if(jQuery(window).width()<=767){
    if(jQuery(".listicle-product-sticky").length>0 && jQuery('.listicle_section').find(".listicle_reasons_grid").length>0){
      var stickyIndex = jQuery('.content-for-layout').find('.listicle_product_sticky').attr('sticky-id');
      if(stickyIndex!="" && stickyIndex!=undefined){
        stickyIndex = (stickyIndex-1);
        var defaultHeight = jQuery('.listicle_section').find(".listicle_reasons_grid").outerHeight();
        var stickyButton = jQuery('.listicle_section').find(".listicle_reasons_grid").eq(stickyIndex).offset().top;
        stickyButton = Math.round(stickyButton-defaultHeight);
        jQuery(window).on('scroll', () => {
          var scrollTop = $(window).scrollTop();
          //console.log("scrollTop",scrollTop,stickyButton);
          if(scrollTop > stickyButton){
            jQuery('.content-for-layout').find('.listicle-product-sticky').addClass('is-active');
          }else{
            jQuery('.content-for-layout').find('.listicle-product-sticky').removeClass('is-active');
          }
        });
      }
    }
  }
});
//LISTICLE PAGE STAR BUTTON STICKY SPECIFIC SECTION SCROLL END

// BUNDLE BUILDER PRODUCT GALLERY -- START
var sliderThumbnail = new Swiper('.bb_gallery_thumbnail', {
  slidesPerView: 5,
  spaceBetween: 12,
  freeMode: true,
  loop: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  breakpoints: {
    1120: {
      slidesPerView: 7
    },
    1024: {
      slidesPerView: 6
    },
    300: {
      slidesPerView: 5
    }
  }
});

var slider = new Swiper('.bb_gallery_slider', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: sliderThumbnail
  }
});
// BUNDLE BUILDER PRODUCT GALLERY -- END

// BUNDLE BUILDER PRODUCT -- START
jQuery(document).ready(function($) {
  var $bundles = $('.bundle_builder_section').find(".bb_bundle_col");
  var $gifts = $('.bundle_builder_section').find(".bundle_builder_gift .bb_gift_col");

  if ($bundles.length > 0) {
    // Example if you want default active:
    // $bundles.eq(2).addClass("active");
  }
  // Activate gifts for default bundle (like first or 3)
  if($gifts.length>0){
    activateGifts(2);
    // Bundle click events
    $bundles.on("click", function() {
      var index = parseInt($(this).attr('data-index'));
      $bundles.removeClass("active");
      $(this).addClass("active");
      var floverActive = index;
      activateGifts(floverActive);

      if(jQuery('.bb_atc_block').find('.bb_atc_subscribe').length>0){
        var getOffText = jQuery('.bb_atc_block').find('.bb_atc_subscribe').attr('data-off'+floverActive);
        if(getOffText!="" && getOffText!=undefined){
          jQuery('.bb_atc_block').find('.bb_atc_subscribe').html(getOffText);
        }
      }
      if(jQuery('.bb_atc_btnlink').find('.bb_atc_prices').length>0){
        jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_compare_price').hide();
        jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_sale_price').hide();
        if(floverActive==1){
          jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_compare_price.one').show();
          jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_sale_price.one').show();
        }else if(floverActive==2){
          jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_compare_price.two').show();
          jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_sale_price.two').show();
        }else if(floverActive==3){
          jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_compare_price.three').show();
          jQuery('.bb_atc_btnlink').find('.bb_atc_prices').find('.bba_sale_price.three').show();
        }
      }

      if($('.bundle_builder_section').find('.bb_atc_btnlink').length>0){
        let href = $('.bundle_builder_section').find('.bb_atc_btnlink').attr("href");
        // Replace quantity=NUMBER with your new value
        console.log("href",href,floverActive);
        href = href.replace(/quantity=\d+/, "quantity="+floverActive); // <-- change number
        $('.bundle_builder_section').find('.bb_atc_btnlink').attr("href", href);
      }
    });
  }

  function activateGifts(count) {
    var $cards = $('.bb_product_gifts.bundle_builder_gift .bb_gift_col');
    $cards.removeClass("active");
    $cards.find(".bb_gift_blank").css("display", "flex");
    $cards.find(".bb_gift_box").hide();
    // Loop each gift card
    $cards.each(function(i) {
      if (i < count) {
        $(this).addClass("active");
        if ($(this).find(".bb_gift_blank").length > 0) {
          $(this).find(".bb_gift_blank").hide();
        }
        if ($(this).find(".bb_gift_box").length > 0) {
          $(this).find(".bb_gift_box").css("display", "flex");
        }
      }
    });
    if(count>0 && jQuery('.bundle_builder_content').find('.bb_buyonce_btn').length>0){
      jQuery('.bundle_builder_content').find('.bb_buyonce_btn').find('.bb_buynow_msg').hide();
      if(count==1){
        jQuery('.bundle_builder_content').find('.bb_buyonce_btn').find('.bb_flabor_one').show();
      }else if(count==2){
        jQuery('.bundle_builder_content').find('.bb_buyonce_btn').find('.bb_flabor_two').show();
      }else if(count==3){
        jQuery('.bundle_builder_content').find('.bb_buyonce_btn').find('.bb_flabor_three').show();
      }
    }
  }
});
// BUNDLE BUILDER PRODUCT -- END

// LANDING ANNOUNCEMENT HEIGHT -- START
$(function(){
  var $root = $('body');
  var cssVar = '--landing-announcement-height';
  function update() {
    var $el = $('.landing-announcement');
    if ($el.length === 0) {
      $root.css(cssVar, '');
      return;
    }
    var h = Math.round($el.outerHeight());
    $root.css(cssVar, h + 'px');
  }
  $(window).on('load resize', update);
  var mo = new MutationObserver(update);
  mo.observe(document.body, { childList: true, subtree: true, attributes: true });
  update();
});
// LANDING ANNOUNCEMENT HEIGHT -- END

// FLAVOR PAGE GALLERY -- START
$('.flavor__product .cp-gallery').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  dots: false,
  arrows: true,
  prevArrow:
    '<button type="button" class="slick-prev slick-arrow" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 30"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.959" d="m11.817 23.382 8.57-8.57-8.57-8.571"/></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next slick-arrow" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 31 30"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.959" d="m11.817 23.382 8.57-8.57-8.57-8.571"/></svg></button>',
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});
// FLAVOR PAGE GALLERY -- END

// START :: TODAY DATE TRANSLATE
document.addEventListener('DOMContentLoaded', function () {
  const dateWrapper = document.getElementById('current-date');
  if (!dateWrapper) return;

  const activeLang =
    dateWrapper.closest('[data-lang]')?.dataset.lang || 'fr';

  const parisToday = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' })
  );

  // ❌ weekday removed
  const dateOptions = {
    day: 'numeric',
    month: 'long'
  };

  let finalLocale = activeLang + '-' + activeLang.toUpperCase();

  try {
    let todayFormatted = parisToday.toLocaleDateString(
      finalLocale,
      dateOptions
    );
    dateWrapper.textContent = todayFormatted;
  } catch (error) {
    dateWrapper.textContent = parisToday.toLocaleDateString(
      'fr-FR',
      dateOptions
    );
  }
});

// END :: TODAY DATE TRANSLATE
let flagpopup = 0;
//BUNDLE BUILDER NUTRAIIONAL POPUP ON CLICK TO ADD CLASS START
jQuery(document).on('click',".bb_nutritional_popup",function () {
  jQuery('.section--nutritional-information').find('.ni-accordion').attr('data-open',false);
    jQuery('.section--nutritional-information').find('.ni-accordion__header').attr('aria-expanded',false);
    jQuery('.section--nutritional-information').find('.ni-accordion__panel').attr('hidden',true);
  jQuery('body').addClass('nutritional_popup_active');
  if(jQuery('.ni-popup-trigger').length>0){
    jQuery('.ni-accordion__header').trigger("click");
    setTimeout(function(){
      jQuery('.ni-popup-trigger').trigger("click");
    },100);
  }
  flagpopup=1;
});

jQuery(document).on("click",".ni-popup__close",function(){
  if(jQuery('body').hasClass('nutritional_popup_active')){
    jQuery('body').removeClass('nutritional_popup_active');
    jQuery('.ni-accordion__header').trigger("click");
  }
});

// Outside click handler
// OUTSIDE CLICK → CLOSE POPUP
$("body").on("click", function (e) {
  if (!$(this).hasClass("nutritional_popup_active")) return;
  if (
    $(e.target).closest(".bb_nutritional_popup").length
  ) {
    return; // click inside popup → do nothing
  }
  closeNutritionalPopup(); // outside click → close
  if (
    $(e.target).closest(".ni-accordion__header").length
  ) {
    flagpopup=0;
  }
});
let lastScrollTop = 0;
$(window).on("scroll", function () {
  if(flagpopup==1){
    if(jQuery('.section--nutritional-information').length>0){
      jQuery('.section--nutritional-information').find(".ni-accordion").attr("data-open", "false");
      jQuery('.section--nutritional-information').find(".ni-accordion__header").attr("aria-expanded", "false");
      jQuery('.section--nutritional-information').find(".ni-accordion__panel").attr("hidden", true);
    }
    flagpopup=0;
  }
});

function closeNutritionalPopup() {
  const $popup = $(".bb_nutritional_popup");

  $popup.find(".ni-accordion").attr("data-open", "false");
  $popup.find(".ni-accordion__header").attr("aria-expanded", "false");
  $popup.find(".ni-accordion__panel").attr("hidden", true);

  $("body").removeClass("nutritional_popup_active");
}
// OPTIONAL: ESC KEY CLOSE
$(document).on("keydown", function (e) {
  if (e.key === "Escape") {
    closeNutritionalPopup();
  }
});

// -------
jQuery(document).on('click', 'a[title="valeursnutritionnelles"]', function (e) {
  e.preventDefault(); // 🚫 stop page jumping to top

  jQuery('.section--nutritional-information')
    .find('.ni-accordion')
    .attr('data-open', false);

  jQuery('.section--nutritional-information')
    .find('.ni-accordion__header')
    .attr('aria-expanded', false);

  jQuery('.section--nutritional-information')
    .find('.ni-accordion__panel')
    .attr('hidden', true);

  jQuery('body').addClass('nutritional_popup_active');

  if (jQuery('.ni-popup-trigger').length > 0) {
    jQuery('.ni-accordion__header').trigger('click');

    setTimeout(function () {
      jQuery('.ni-popup-trigger').trigger('click');
    }, 100);
  }
});

//BUNDLE BUILDER NUTRAIIONAL POPUP ON CLICK TO ADD CLASS END
